import { render, staticRenderFns } from "./SystemInfo.vue?vue&type=template&id=d71e858a&scoped=true&"
import script from "./SystemInfo.vue?vue&type=script&lang=js&"
export * from "./SystemInfo.vue?vue&type=script&lang=js&"
import style0 from "./SystemInfo.vue?vue&type=style&index=0&id=d71e858a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d71e858a",
  null
  
)

export default component.exports